import './AnimalSelectorPage.scss';

import { useState } from 'react';
import { useApp } from '../app-context';
import { TSPage } from '../components/commons';
import { DashService } from '../services/DashService';
import {Utils} from "../Utils";

const Header = ({ onBack }) => {
    return (
        <div className="popup-header">
            <button className="back"><img src="/img/arrow-right.svg" alt="back" onClick={onBack} /></button>
            <h3>בחירת חיה</h3>
            <button className="more"><img src="/img/more-white.svg" alt="menu" /></button>
            <button className="closer backBtn" onClick={onBack}>
                <img src="/img/close.svg" alt="close" />
                סגור
            </button>
        </div>
    );
};

const AnimalItem = ({ pet, onSelected, selected }) => {
    return (
        <button className={`pet-item ${selected ? "selected" : ""}`} onClick={onSelected?.bind(this, pet)}>
            <img src={`/img/avatar-${pet.type}.svg`} alt="" />
            {pet.name}
        </button>
    );
};

const AnimalSelectorPage = (props) => {
    const [state, dispatcher] = useApp();
    const [stateSelectedPet, setSelectedPet] = useState(undefined);
    const [stateBusy, setBusy] = useState(false);

    const handleClose = (e) => {
        e.preventDefault();
        dispatcher({ action: "closePage", params: { id: "animalSelector" } });
    };

    const handleSelectedPet = (pet, e) => {
        setSelectedPet(pet);
    };

    const handleSubmit = async (e) => {
        if (!stateSelectedPet || stateBusy) return;

        try {
            setBusy(true);
            let data = await DashService.openClaim(state._token, stateSelectedPet.policyId, stateSelectedPet.petPlace);
            dispatcher({ action: 'showPage', params: { id: 'botClaim', props: { botScript: data.claimScript, botToken: data.claimSession } } })

            dispatcher({ action: 'closePage', params: { id: "animalSelector" } });
        } catch (ex) {
            Utils.displaySimpleMsg(dispatcher, ex?.message || "שגיאה לא ידועה");
        } finally {
            setBusy(false);
        }
    };

    let pets = state.profile?.pets || [];
    let newPets = [];
    for (let i = 0; i < pets.length; i++) {
        if (props.policyId) {
            if (pets[i].id === props.policyId) {
                let copy = { ...pets[i] };
                //copy.petPlace = ii;
                newPets.push(copy);
            }
        } else {
            newPets.push(pets[i]);
        }
    }
    return (
        <TSPage name={props.name} className="rollup fast" pageState={props?.pageState}>
            <div className="height-limiter">
                <div className="container">
                    <Header onBack={handleClose} />
                    <h2 className="fixed">כדי להמשיך בתהליך התביעה יש ללחוץ על שם החיה</h2>
                    <div className="content">
                        {newPets.map((v, k) => <AnimalItem key={`pet${k}`} pet={v} selected={stateSelectedPet?.id === v.id && stateSelectedPet?.petPlace === v.petPlace} onSelected={stateBusy ? undefined : handleSelectedPet} />)}
                    </div>
                    <div className="fixed bottom">
                        <button className="yellow" disabled={!stateSelectedPet || stateBusy} onClick={handleSubmit}>המשך</button>
                    </div>
                </div>
            </div>
        </TSPage>
    );
}

export { AnimalSelectorPage }
